import ServiceDetailPage from "@/components/ServiceDetailPage";

const TeamExpression = () => <ServiceDetailPage pageKey="teamExpression" />;

export default TeamExpression;
